import { Text } from 'wix-ui-tpa/cssVars';
import React from 'react';
import type { Modifier as _Modifier } from 'root/apiTypes';
import { useModifierLogic } from './Modifier.logic';
import { classes } from './Modifier.st.css';
import { dataHooks } from 'root/dataHooks';
import { Plus } from '@wix/wix-ui-icons-common/on-stage';

export const Modifier = ({
  modifier,
  reference,
}: {
  modifier: _Modifier;
  reference?: React.RefObject<HTMLDivElement>;
}) => {
  const { formattedPrice, shouldShowModifiersPrice, modifierTitleHtmlTag } = useModifierLogic({
    modifier,
  });
  return (
    <div
      ref={reference}
      aria-labelledby={modifier.id}
      className={classes.modifierContainer}
      data-hook={dataHooks.item.modifier(modifier.id)}
      role="listitem"
      tabIndex={0}
    >
      <div className={classes.modifierDetails}>
        <Plus className={classes.plusIcon} />
        <Text className={classes.modifierName} data-hook={dataHooks.modifier.name} tagName={modifierTitleHtmlTag}>
          {modifier?.name}
        </Text>
        {shouldShowModifiersPrice && (
          <Text className={classes.modifierPrice} data-hook={dataHooks.modifier.price}>
            {formattedPrice}
          </Text>
        )}
      </div>
    </div>
  );
};
